import { render, staticRenderFns } from "./couponGiveReceiveEdit.vue?vue&type=template&id=0b6a66f4&"
import script from "./couponGiveReceiveEdit.vue?vue&type=script&lang=js&"
export * from "./couponGiveReceiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports